import { Col, Row } from "react-bootstrap";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { NFLookupInput } from "../../../Shared/NewForms/NFLookupInput";
import { NFDateInput } from "../../../Shared/NewForms/NFDateInput";
import { NFLookupAccount } from "../../../Shared/NewForms/NFLookupAccount";
import { useTranslation } from "react-i18next";
import { NFLookupContract } from "../../../Shared/NewForms/NFLookupContract";
import { NFLookupCustomer } from "../../../Shared/NewForms/NFLookupCustomer";
import { NFLookupCompany } from "../../../Shared/NewForms/NFLookupCompany";
import { NFIntInput } from "../../../Shared/NewForms/NFIntInput";
import { NFLookupVendor } from "../../../Shared/NewForms/NFLookupVendor";

const VendorSettlementAnalyticsDetailMain = () => {
  const { t } = useTranslation();

  return (
    <>
      <Row>
        <Col sm={6}>
          <NFTextInput title={t("Name")} fieldName={"name"} />
        </Col>
        <Col sm={6}>
          <NFDateInput title={t("CreatedDate")} fieldName="createdDate" />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFTextInput title={t("UniqueCode")} fieldName={"uniqueCode"} />
        </Col>
        <Col sm={6}>
          <NFIntInput title={t("ReferenceType")} fieldName="referenceType" />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFLookupContract title={t("Contract")} fieldName={"contractId"} />
        </Col>
        <Col sm={6}>
          <NFLookupVendor title={t("Vendor")} fieldName={"vendorId"} />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFLookupCompany title={t("Company")} fieldName="companyId" />
        </Col>
      </Row>
    </>
  );
};

export default VendorSettlementAnalyticsDetailMain;
